<div *ngIf="pages > 1">
  <ul class="pagination pagination__horizontal" role="navigation">
    <li class="pagination--item" *ngIf="page > 1">
      <a href="javascript:undefined" class="focus-element" (click)="selectPage(page  - 1)">
        <span class="focus--content" tabindex="-1">
          <svg class="pagination--arrow previous"><use xlink:href="#ic-arrow" href="#ic-arrow"></use></svg>
        </span>
      </a>
    </li>
    <li class="pagination--item" *ngIf="page > 4">
      <a href="javascript:undefined" class="focus-element" (click)="selectPage(1)">
        <span class="focus--content" tabindex="-1">1</span>
      </a>
    </li>
    <li class="pagination--item" *ngIf="page > 4">...</li>
    <li class="pagination--item" *ngFor="let pageNumber of pageNumbers">
      <a href="javascript:undefined" class="focus-element" [ngClass]="{'active' : pageNumber === page}" (click)="selectPage(pageNumber)"><span class="focus--content" tabindex="-1">{{pageNumber}}</span></a>
    </li>
    <li class="pagination--item" *ngIf="page < pages - 5 && page != pages">...</li>
    <li class="pagination--item" *ngIf="page < pages - 5 && page != pages">
      <a href="javascript:undefined" class="focus-element" (click)="selectPage(pages)">
        <span class="focus--content" tabindex="-1">{{pages}}</span>
      </a>
    </li>
    <li class="pagination--item" *ngIf="pageNumbers.length > 0 && pages > pageNumbers[pageNumbers.length-1]">
      <a href="javascript:undefined" class="focus-element" (click)="selectPage(page + 1)">
        <span class="focus--content" tabindex="-1">
          <svg class="pagination--arrow next"><use xlink:href="#ic-arrow" href="#ic-arrow"></use></svg>
        </span>
      </a>
    </li>
  </ul>
</div>
